
document.addEventListener("ajaxloader:render", notifyPopupOpenEvent, {once:true});
document.addEventListener("DOMContentLoaded", notifyPopupOpenEvent, {once:true});
function notifyPopupOpenEvent(){
  $('a[href="#wear-form"]').click(function(){
    $('.modal-container').addClass('popup-show');

    var Notification = $(this).attr('notification');
    // console.log(Notification,'Notification');
    if (Notification) {
      $('input[name="User From"]').val(Notification);
    }
  
    if ($(this).attr('current-product')) {
      var CurrentProductUrl = $(this).attr('current-product');
      var CurrentProductTitle = $(this).attr('product-title');
      
      // var GetCurrentProductTitle = CurrentProductUrl.split("/");
      // var CurrentProductTitle = GetCurrentProductTitle[2].replace(/-/g, " ");
      
      $('input[name="Url"]').val('https://www.wearcomet.com' + CurrentProductUrl);
      $('input[name="Title"]').val(CurrentProductTitle);
    }
  })
}$('.popup-close').click(function(){
  if($('.modal-container').hasClass('popup-show')){
     $('.modal-container').removeClass('popup-show');
  }

  setTimeout(() => {
    var ShowForm = document.getElementById('wear-comet');
    ShowForm.style.display="block";
    $('.thank-you-message').hide();
    $('#form-title').show();
    ShowForm.reset();
  }, "1000");
})  

$('.modal-overlay').click(function(){
  if($('.modal-container').hasClass('popup-show')){
     $('.modal-container').removeClass('popup-show');
  }

  setTimeout(() => {
    var ShowForm = document.getElementById('wear-comet');
    ShowForm.style.display="block";
    $('.thank-you-message').hide();
    $('#form-title').show();
    ShowForm.reset();
  }, "1000");
})   
  
window.addEventListener("load", function() {

// Update Variant
document.addEventListener('product:variant:changed',function(e){
  const data = e['detail'];
  if(data && data['variant']){
    const variant_name  = data['variant']['name'];
    window.wc_current_selected_variant = variant_name;
  }else{
    window.wc_current_selected_variant = null;
  }
  // console.log(window.wc_current_selected_variant);
});
});

function notifyForm(){
  const form = document.getElementById('wear-comet');
  form.addEventListener("submit", function(e) {
    e.preventDefault();
    document.querySelector("#wear-comet .submit-button").disabled = true;
    document.getElementById("popup-form-btn-loader").style.display = "block";
    document.getElementById("popup-form-btn-text").style.display = "none";
    const data = new FormData(form);

    // Update Variant Data
    if(window.wc_current_selected_variant){
      data.append('Variant Name' ,window.wc_current_selected_variant);
    }
    
    const action = e.target.action;
    fetch(action, {
      method: 'POST',
      body: data,
    })
    .then(() => {
        form.style.display="none";
        $('.thank-you-message').show();
         document.getElementById("popup-form-btn-loader").style.display = "none";
         document.getElementById("popup-form-btn-text").style.display = "block";
         document.querySelector("#wear-comet .submit-button").disabled = false;
        $('#form-title').hide();
    })
  });
}

notifyForm();  
  